// extracted by mini-css-extract-plugin
module.exports = {"customVideoPlayer":"CustomVideoPlayer_customVideoPlayer__VYiwQ","pre-playback":"CustomVideoPlayer_pre-playback__RwMKc"};